import styled from "styled-components";
import { FaRegEdit } from 'react-icons/fa';
import {BsCheck2Square, BsPersonAdd, BsPersonDash} from 'react-icons/bs';
import { BiAddToQueue } from "react-icons/bi";

export const Title = styled.div`
  color: white;
  text-align: center;
  flex: 1;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  margin-right: 1rem;
`

export const TitleEditIcon = styled(FaRegEdit)`
  font-size: 1.5rem; 
  color: white;
`

export const TitleSaveIcon = styled(BsCheck2Square)`
  font-size: 1.5rem;
  color: white;
`

export const AddActivityIcon = styled(BiAddToQueue)`
  font-size: 1.5rem;
  cursor: pointer;
`

export const AddIcon = styled(BsPersonAdd)`
  font-size: 1.5rem;
  cursor: pointer;
  margin-right: 1rem;
`

export const DeleteIcon = styled(BsPersonDash)`
  font-size: 1.5rem;
  cursor: pointer;
`